import classNames from "classnames";

import {Accordion} from "@/components/accordion/Accordion.tsx";
import {Icon} from "@/components/icon/Icon.tsx";
import {SectionProps} from "@/components/section/Section.types.ts";

import styles from "./Section.module.scss";

const EVENT_KEY = "0";

export const Section = ({
  title,
  icon,
  description,
  children,
  collapsible = children != null,
  defaultOpen = false,
  headerProps,
  className,
  ...rest
}: SectionProps) => {
  const headerContent = (
    <div className={styles.headerContent}>
      {icon && <Icon icon={icon} size="chip" removeDivDimensions />}
      <div className={styles.title} {...headerProps}>
        {title}
      </div>
      <div className={styles.dividerLine} />
    </div>
  );

  if (!collapsible) {
    return (
      <section className={classNames(styles.section, className)} {...rest}>
        <div className={styles.header}>{headerContent}</div>
        {description && <div className={styles.description}>{description}</div>}
        {children && <div className={styles.body}>{children}</div>}
      </section>
    );
  }

  return (
    <Accordion
      as="section"
      defaultActiveKey={defaultOpen ? EVENT_KEY : undefined}
      className={classNames(styles.section, className)}
      {...rest}
    >
      <Accordion.Item eventKey={EVENT_KEY}>
        <Accordion.Header className={classNames(styles.header, styles.headerCollapsible)}>
          {headerContent}
        </Accordion.Header>
        {description && <div className={styles.description}>{description}</div>}
        <Accordion.Body className={styles.body}>{children}</Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
};
